import classNames from 'classnames'

import { getQaSelector } from '../../../../../../utils/common'
import { AVATAR_HEIGHT_32 } from '../../../../../Avatar'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../../Icon'
import { Status, STATUS_SIZE_20 } from '../../../../../Status'
import Text from '../../../../../Text'
import { ApplicantDecisionNote } from '../ApplicantDecisionNote'
import { ApplicantDecisionUser } from '../ApplicantDecisionUser'

import * as styles from '../ApplicantDecisionPanel.module.css'

import InformationIcon from '../../../../../../icons/info.svg'

function ApplicantDecisionLedgerRow({
  children,
  hint,
  isMuted,
  label,
  note,
  qaName,
  statusProps,
  step,
  text,
  user,
}) {
  return (
    <div {...getQaSelector({ value: qaName })} className={styles.ledgerRow}>
      {label ? (
        <div className={styles.ledgerLabelRow}>
          {step ? <Text className={styles.ledgerStep}>{step}</Text> : null}
          <Text isSecondary className={styles.ledgerLabel}>
            {label}
          </Text>
          {hint ? (
            <IconWithTooltip
              Icon={InformationIcon}
              size={ICON_HEIGHT_16}
              svgSize={ICON_HEIGHT_16}
              tooltip={hint}
            />
          ) : null}
        </div>
      ) : null}
      <div className={styles.ledgerValue}>
        <div className={styles.ledgerHead}>
          {user ? (
            <ApplicantDecisionUser
              avatarSize={AVATAR_HEIGHT_32}
              isMuted={isMuted}
              value={user}
            />
          ) : null}
          {statusProps ? (
            <Status {...statusProps} height={STATUS_SIZE_20} />
          ) : null}
          {text ? (
            <Text
              isSecondary
              className={classNames(styles.ledgerText, {
                [styles.mutedUser]: isMuted,
              })}
            >
              {text}
            </Text>
          ) : null}
        </div>
        {children}
        {note ? <ApplicantDecisionNote {...note} /> : null}
      </div>
    </div>
  )
}

export default ApplicantDecisionLedgerRow
